import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useRequestAccessMutation } from 'services/api/ums';
import { isValidEmail } from '../helpers';
import { StyledModal } from './style';

function RequestAccessModal({ show, onHide }) {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setEmail('');
    setReason('');
    setError('');
  }, [show]);

  const [request, requestState] = useRequestAccessMutation();

  useEffect(() => {
    if (requestState.isError) {
      setError(get(requestState, 'error.data.message'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestState.isError]);

  useEffect(() => {
    if (requestState.isSuccess) {
      toast.success(get(requestState, 'data.message'));
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestState.isSuccess]);

  return (
    <StyledModal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Request Access</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group
          className={
            !email
              ? 'form-group'
              : isValidEmail(email)
                ? 'form-group success'
                : 'form-group error'
          }
        >
          <Form.Label>Email Address *</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className={!reason ? 'form-group' : 'form-group success'}>
          <Form.Label>Reason For Requesting Access *</Form.Label>
          <Form.Control
            as="textarea"
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </Form.Group>
        {error && <div className="error-message">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={!isValidEmail(email) || !reason || requestState.isLoading}
          onClick={() => request({ email, note: reason })}
        >
          Request Access
        </Button>
        <Button onClick={onHide} variant="secondary">
          Cancel
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
}

export default RequestAccessModal;
